import { render, staticRenderFns } from "./ColorCheckbox.vue?vue&type=template&id=fab8470e"
import script from "./ColorCheckbox.vue?vue&type=script&lang=js"
export * from "./ColorCheckbox.vue?vue&type=script&lang=js"
import style0 from "./ColorCheckbox.vue?vue&type=style&index=0&id=fab8470e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports